import React, { useMemo } from "react";
import { Modal, Button } from "antd";
import { translations } from "../../utils/Translation/staticTranslation";
import "../../styles/Pages/create-roles.css";

/**
 * Confirm removing superadmin access (`mode: "revoke"`) or cancelling a pending invite (`mode: "cancel_invite"`).
 * Styled like Create User modal.
 */
const RevokeUserConfirmModal = ({
  open,
  onClose,
  onConfirm,
  loading,
  mode = "revoke",
}) => {
  const lang = localStorage.getItem("language") || "ar";
  const t = translations[lang]?.createRolesPage || {};
  const isRTL = lang === "ar";

  const isCancelInvite = mode === "cancel_invite";

  const modalTitle = useMemo(
    () => (
      <div className="create-user-modal-title-wrap">
        <div className="create-user-modal-title-main">
          {isCancelInvite
            ? t.cancel_invite_confirm_title
            : t.revoke_user_confirm_title}
        </div>
      </div>
    ),
    [
      isCancelInvite,
      t.cancel_invite_confirm_title,
      t.revoke_user_confirm_title,
    ],
  );

  const bodyDesc = isCancelInvite
    ? t.cancel_invite_confirm_desc
    : t.revoke_user_confirm_desc;

  const confirmLabel = isCancelInvite ? t.cancel_invite_ok : t.revoke_user_ok;

  return (
    <Modal
      title={modalTitle}
      open={open}
      onCancel={onClose}
      width={480}
      centered
      destroyOnClose
      footer={null}
      className="create-user-modal revoke-user-confirm-modal"
      maskClosable={!loading}
      closable={!loading}
    >
      <div className="create-user-modal-inner" dir={isRTL ? "rtl" : "ltr"}>
        <p className="revoke-user-confirm-desc">{bodyDesc}</p>

        <div className="create-user-modal-footer revoke-user-confirm-footer">
          <Button
            type="default"
            className="create-user-modal-cancel"
            onClick={onClose}
            disabled={loading}
          >
            {t.cancel}
          </Button>
          <Button
            className="revoke-user-confirm-submit"
            onClick={onConfirm}
            loading={loading}
            disabled={loading}
          >
            {confirmLabel}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default RevokeUserConfirmModal;
